/**
 * Deep D: three steel vaults and a chain of keys. The gold key lies near the start, the jade key
 * is in the gold vault and the ruby key in the jade vault; the ruby vault is the prize
 * (docs/spec/03 §3).
 */

import type { CaveDef } from '../types';

export const deepD: CaveDef = {
  id: 'D',
  name: 'LOCKSMITH',
  hint: 'Each vault holds the key to the next. Ruby pays best.',
  intermission: false,
  colors: [11, 15, 7],
  diamondValue: 17,
  extraValue: 25,
  fill: { base: '.', items: [['r', 12], ['d', 4]] },
  levels: [
    { seed: 5401, diamonds: 16, time: 160 },
    { seed: 5402, diamonds: 20, time: 150 },
    { seed: 5403, diamonds: 24, time: 140 },
    { seed: 5404, diamonds: 28, time: 130 },
    { seed: 5405, diamonds: 32, time: 120 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
    'W??????????????????.....???????????????W',
    'W??????????????????..P..???????????????W',
    'W???????????.1.????.....???????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W?WWWWWWWWW??????????????????WWWWWWWWW?W',
    'W?Wd.d.d.dW??????????????????Wdd.d.ddW?W',
    'W?W.d.2.d.W??????????????????Wd.d3d.dW?W',
    'W?Wd.ddd.d4.????????????????.5ddd.dddW?W',
    'W?WWWWWWWWW??????????????????WWWWWWWWW?W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W?????????????WWWWWWWWWWWW?????????????W',
    'W?????????????Wd.dd.dd.ddW?????????????W',
    'W?????????????Wdd.dddd.ddW?????????????W',
    'W?????????????Wd.dd.dd.ddW?????????????W',
    'W????????????.6ddddddddddW?????????????W',
    'W?????????????WWWWWWWWWWWW?????????????W',
    'W????????????????????????????????????X?W',
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
  ],
};
